import FormInput from './FormInput'

export default FormInput



// WEBPACK FOOTER //
// ./src/components/Form/Input/index.js